/* ============================================================
   listicle-v6 — behaviours re-implemented from the Claude Design export
   (its own script was read, then discarded; work/02-read.md). Namespace: lpl6.
     1. Offer gallery: previous / next arrows wrapping around, one thumbnail
        per photo (the current one carries aria-current and the highlight
        outline), arrow keys when the gallery has focus, a polite live line
        saying which photo is showing.
     2. Buy bar: its button jumps to the offer (a plain #lpl6-offer link);
        smooth scrolling unless the visitor asked for reduced motion.
   The headline highlight, the reason overlays and the add-to-cart form need
   no script (Liquid + the product form). Rebinds on shopify:section:load so
   the editor never double-binds.
   ============================================================ */
(function () {
  'use strict';
  var BOUND = 'lpl6Bound';

  function each(scope, sel, fn) { Array.prototype.forEach.call(scope.querySelectorAll(sel), fn); }

  function initGallery(box) {
    if (box.dataset[BOUND]) return;
    box.dataset[BOUND] = '1';
    var slides = box.querySelectorAll('[data-lpl6-slide]');
    var thumbs = box.querySelectorAll('[data-lpl6-thumb]');
    var live = box.querySelector('[data-lpl6-live]');
    var n = slides.length, i = 0;
    if (n < 2) return;
    function go(k) {
      i = (k + n) % n;
      Array.prototype.forEach.call(slides, function (s, j) { s.hidden = j !== i; });
      Array.prototype.forEach.call(thumbs, function (t, j) {
        if (j === i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
      });
      if (live && thumbs[i]) live.textContent = thumbs[i].getAttribute('aria-label');
      if (thumbs[i] && thumbs[i].scrollIntoView && thumbs[i].parentNode.scrollWidth > thumbs[i].parentNode.clientWidth) {
        thumbs[i].parentNode.scrollLeft = thumbs[i].offsetLeft - thumbs[i].parentNode.offsetLeft;
      }
    }
    each(box, '[data-lpl6-prev]', function (b) { b.addEventListener('click', function () { go(i - 1); }); });
    each(box, '[data-lpl6-next]', function (b) { b.addEventListener('click', function () { go(i + 1); }); });
    Array.prototype.forEach.call(thumbs, function (t) {
      t.addEventListener('click', function () { go(parseInt(t.getAttribute('data-lpl6-thumb'), 10) || 0); });
    });
    box.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(i - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); go(i + 1); }
    });
  }

  function initJump(a) {
    if (a.dataset[BOUND]) return;
    a.dataset[BOUND] = '1';
    a.addEventListener('click', function (e) {
      var target = document.getElementById('lpl6-offer');
      if (!target) return;
      e.preventDefault();
      var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      target.scrollIntoView({ behavior: still ? 'auto' : 'smooth', block: 'start' });
    });
  }

  function init(scope) {
    var s = scope || document;
    each(s, '[data-lpl6-gal]', initGallery);
    each(s, 'a[href="#lpl6-offer"]', initJump);
  }

  window.lpl6 = { version: '1.0', init: init };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
